import React from "react";
import {
  Button,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Image,
  Box,
  Text,
} from "@chakra-ui/react";
import DeleteIcon from "@assets/icons/delete-02.svg";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description?: string;
  chatCountDescription?: string;
  deleteButtonTitle: string;
  cancelButtonTitle: string;
  isLoading?: boolean;
}

export const ModalDelete: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  chatCountDescription,
  deleteButtonTitle = "Confirm",
  cancelButtonTitle = "Cancel",
  isLoading = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="rgba(0, 0, 0, 0.4)" />
      <ModalContent
        bg="white"
        borderRadius="20px"
        p="44px 26px 26px 26px"
        w="526px"
        border="4px solid #FFF"
        boxShadow="0px 3px 11px 0px rgba(24, 25, 180, 0.06), 0px 10px 18px 0px rgba(24, 25, 180, 0.06)"
      >
        <Flex direction="column" align="center" gap="24px">
          {/* Icon Circle */}
          <Box
            borderRadius="50%"
            bg="#F5F5F5"
            width="80px"
            height="80px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Image
              height="40px"
              width="40px"
              src={DeleteIcon}
              filter="brightness(0)"
            />
          </Box>

          {/* Title */}
          <Text fontWeight="20px" fontFamily="Noto Sans KR" textAlign="center">
            {title}
          </Text>

          {/* Description */}
          <Text fontFamily="Noto Sans KR" textAlign="center">
            {chatCountDescription || description}
          </Text>
        </Flex>

        {/* Buttons */}
        <ModalFooter justifyContent="center" gap="12px" mt="32px" p={0}>
          <Button
            fontFamily="Noto Sans KR"
            bg="white"
            color="#2F2F34"
            border="2px solid #E6E6E6"
            borderRadius="16px"
            h="48px"
            w="219px"
            onClick={onClose}
            _hover={{ bg: "#F5F5F5" }}
          >
            {cancelButtonTitle}
          </Button>
          <Button
            fontFamily="Noto Sans KR"
            bg="black"
            color="white"
            border="none"
            borderRadius="16px"
            h="48px"
            w="219px"
            onClick={onConfirm}
            isLoading={isLoading}
            _hover={{ bg: "#3d3535ff" }}
          >
            {deleteButtonTitle}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
